import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import { withRouter } from "react-router-dom";
import moment from "moment";
import Dialog from 'material-ui/Dialog';

import { Select } from "./Select";

import { TABS, FilterTypes } from "../constants";

import HttpClient from 'services/HttpClient';

const SESSION_API = '/api/v1/sessions';
const LAST_SESSION_API = `${SESSION_API}/last_active`;

@withRouter
@inject("userStore")
@inject("mcqThemesStore")
@inject("mcqSessionFiltersStore")
@inject("mcqSessionStore")
@inject('alertStore')
@observer
export class Dashboard extends Component {
  constructor() {
    super();

    this.state = {
      isConfirmModalOpened: false,
    };
  }

  componentDidMount() {
    const { mcqSessionStore, alertStore } = this.props;

    new HttpClient().get(LAST_SESSION_API, false)
    .then(({ body }) => {
      mcqSessionStore.setLastSession(body.data.session);
    })
    .catch(error => {
      if (error.status === 404) {
        mcqSessionStore.setLastSession({});
      } else {
        alertStore.error('Something went wrong.');
      }
    });
  }

  handleSession = () => {
    const { mcqSessionStore: { lastSession }, history, match } = this.props;
    const id = match.params.id;

    history.push(`/exam-prep/${id}/mcq/${lastSession.id}`);
  };

  endSession = () => {
    const { history, match, mcqSessionStore: { lastSession } } = this.props;
    const id = match.params.id;

    new HttpClient().post(`${SESSION_API}/${lastSession.id}/end_session`)
    .then(() => {
      history.push(`/exam-prep/${id}/mcq/performance/${lastSession.id}`);
    })
    .catch(() => {
      alertStore.error('Something went wrong. Please try again.');
    });
  };

  handleOpenConfirmModal = () => {
    this.setState({
      isConfirmModalOpened: true,
    });
  };

  handleCloseConfirmModal = () => {
    this.setState({
      isConfirmModalOpened: false,
    });
  };

  renderLastSession = () => {
    const { mcqSessionStore: { lastSession }, mcqThemesStore: { mcq_themes } } = this.props;
    const themes = lastSession.theme_ids.length === mcq_themes.length ?
      [{ id: 1, title: 'All categories specified' }] :
      mcq_themes.filter(theme => lastSession.theme_ids.includes(theme.id));

    return (
      <div className="mcq-card mcq-card-row-between">
        <div className="mcq-card-text-wrapper">
          <p className="text-lg font-bolder">My Last Session</p>
          <span className="font-normal">{themes.map(theme => <span className="mx-8">{theme.title}</span>)}</span>
          <p className="font-normal">{`Start Date: ${moment(performance.started_at).format('DD/MM/YYYY')}`}</p>
          <p className="font-normal">{FilterTypes[lastSession.filter_type]}</p>
          <p className="font-normal opacity-70">{`Question ${lastSession.answered_count} of ${lastSession.mcq_question_count}`}</p>
        </div>
        <div style={{display: 'flex', gap: '16px'}}>
          <button className="btn-new-main" onClick={this.handleSession}>Continue</button>
          <button className="btn-new-red" onClick={this.handleOpenConfirmModal}>End Session</button>
        </div>
      </div>
    );
  }

  renderNoLastSession = () => {
    return (
      <div className="mcq-card mcq-card-row-between">
        <div>
          <p>You have no last session</p>
        </div>
      </div>
    );
  }

  render() {
    const {
      userStore,
      mcqThemesStore: { mcq_themes },
      mcqSessionFiltersStore: { theme_ids, setThemes },
      handleTabChange,
      mcqSessionStore: { lastSession },
    } = this.props;
    const { isConfirmModalOpened } = this.state;
    const themes = mcq_themes.map(theme => ({value: theme.id, title: theme.title}))

    return (
      <div className="mcq-tab">
        <Dialog
          className="modal-wrapper category-handle"
          title='Are you sure you want to end the session?'
          modal={true}
          open={isConfirmModalOpened}
          customContentStyle={{
            height: '100%',
            maxHeight: 'none',
          }}
          bodyClassName="modal-content"
          repositionOnUpdate={true}
          autoDetectWindowHeight={true}
          autoScrollBodyContent={false}>
          <div className="button-set">
            <button
              className="btn gray small transparanted cancel-btn"
              type="reset"
              onClick={this.handleCloseConfirmModal}
            >
              No
            </button>
            <button
              className="btn gray small transparanted apply-btn"
              type="submit"
              onClick={this.endSession}
            >
              Yes
            </button>
          </div>
        </Dialog>
        <h3>{`Hello, ${userStore.user.first_name}`}</h3>
        <div className="mcq-dashboard">
          <Select
            fullWidth
            multiple
            elements={themes}
            value={theme_ids.length > 0 ? theme_ids : ''}
            onChange={(e) => setThemes(e.target.value)}
            floatingLabelText="All Categories"
          />
          <div className="mcq-card mcq-card-row-between">
            <p className="text-lg font-bolder">New Session</p>
            <button className="btn-new-main" onClick={() => handleTabChange(TABS.SESSIONS)}>Start now</button>
          </div>
          {lastSession.id ? this.renderLastSession() : this.renderNoLastSession()}
        </div>
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/modules/mcq/components/Dashboard.js